declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const pushGtag = (props: any = {}) => {
  if (
    process.env.REACT_APP_GTM_CODE !== "" &&
    process.env.REACT_APP_GTM_CODE !== null &&
    process.env.REACT_APP_GTM_CODE !== undefined
  ) {
    window.dataLayer.push({
      ...props,
    });
  }
};
